export enum ROLES {
  TRIP_OWNER = "trip owner",
  TRIP_MATE = "trip mate",
  ADMIN = "admin",
  UNAUTHORIZED = "unauthorized",
}
